import { JSX } from 'react';
import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    Datagrid,
    EditButton,
    SelectField,
    SearchInput,
    TextInput,
    SelectInput,
    ReferenceField
} from 'react-admin';
const types: { id: string, name: string }[] = [
    { id: 'general', name: 'General' },
    { id: 'mini', name: 'Mini' },
];

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

const statuses: { id: string, name: string }[] = [
    { id: 'enabled', name: 'Enabled' },
    { id: 'disabled', name: 'Disabled' },
];

const requestFilter: JSX.Element[] = [
    // <SearchInput source="q" alwaysOn />,
    <TextInput label="Name" source="name" />,
    <SelectInput label="Status" source="status" choices={ statuses } />
];

export const CustomerTutorialList: () => JSX.Element = (): JSX.Element => {



    return (
        <List
            actions={<ListActions/>}
            filters={ requestFilter }
            sort={{ field: 'id', order: 'DESC' }}
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name" />
                <SelectField source="status" choices={ statuses } />
                <SelectField source="type" choices={ types } />
                <ReferenceField reference="nok_minis" source="mini" />
                <EditButton />
            </Datagrid>
        </List>
    );
}
